module.exports = __webpack_public_path__ + "static/media/app_ic_farm_stone.9c001901.png";